import { AttachmentIcon } from '../../../../icons';
import { Avatar } from '../../../Avatar/Avatar';
import { Flex } from '../../../Flex/Flex';
import { Text } from '../../../Text/Text';
import { type FilePreviewType } from '../../AvatarDropzone.types';

interface FilePreviewProps {
    rounded?: boolean;
    filePreview: FilePreviewType;
}

export const FilePreview = ({ filePreview, rounded = false }: FilePreviewProps) => {
    if (filePreview.type === 'image') {
        return (
            <Avatar
                size={100}
                src={filePreview.previewUrl}
                alt={filePreview.fileName}
                shape={rounded ? 'circle' : 'square'}
            />
        );
    }

    if (filePreview.type === 'document' || filePreview.type === 'unspecified') {
        return (
            <Flex direction='column' alignItems='center' justifyContent='center' spacing='4'>
                <AttachmentIcon size={24} color='midnight80' />

                <Text
                    font='label'
                    textAlign='center'
                    fontSize='xsmall'
                    fontWeight='regular'
                    color='midnight80'
                    ellipsis={2}
                    spacing='0 8'
                >
                    {filePreview.fileName}
                </Text>
            </Flex>
        );
    }

    return null;
};
